export const businessClientDefaultFilter = { archived: false };
export const siteDefaultFilter = {
  archived: false,
  inductionRequired: false,
  businessClient: undefined,
};
